import { Vue } from 'vue-property-decorator';
import { Component } from 'vue';

export default class AccordionItem {
  icon!: string;
  title!: string;
  component!: Component;
  props?: object;

  constructor(
    icon: string,
    title: string,
    component: Component,
    props?: object
  ) {
    this.icon = icon;
    this.title = title;
    this.component = component;
    this.props = props;
  }
}
